function smoothScroll() {
  const forms = document.querySelectorAll( '[id^="mktoForm"]' );

  if ( !forms ) {
    return;
  }

  const OFFSET = 350;
  const anchors = document.querySelectorAll( 'a[href^="#mktoForm"]' );

  anchors.forEach( anchor => {
    anchor.addEventListener( 'click', function( e ) {
      const href = this.getAttribute( 'href' );
      const targetId = href.substring( 1 );
      const targetElement = document.getElementById( targetId );

      if ( targetElement ) {
        e.preventDefault();
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - OFFSET;

        window.scrollTo( {
          top: offsetPosition,
          behavior: 'smooth'
        } );
      }
    } );
  } );
}

smoothScroll();